<template>
  <el-dialog
    title="视频播放"
    :visible.sync="playerVisible"
    width="65%"  
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    top
    :before-close="onClose"
    @open="onOpen()"
  >
    <div class="item">
      <div class="player">
        <video-player
          class="vjs-custom-skin"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
          @loadeddata="onPlayerLoadeddata($event)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying($event)"
          @timeupdate="onPlayerTimeupdate($event)"
          @canplay="onPlayerCanplay($event)"
          @canplaythrough="onPlayerCanplaythrough($event)"
          @ready="playerReadied"
          @statechanged="playerStateChanged($event)"
        ></video-player>
      </div>
    </div>
  </el-dialog>
</template>

<script>
// custom skin css
import { getVideo } from "../service/player.service";
import {
  getStore,
  setStore,
  saveAdminInStore,
  isInRole,
  isFrontDesk
} from "../config/mUtils";

export default {
  name: "videoPplayer",
  data() {
    return {
      // videojs options
      playerOptions: {
        height: "700",
        autoplay: true,
        muted: false,
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            // mp4
            src: ""
            //src: "http://vjs.zencdn.net/v/oceans.mp4",
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }
        ],
        poster:
          "http://www.speedupedu.com/images/header-home3.png?crc=303125658"
      }
    };
  },
  props: {   
    playerVisible: false,
    url:String 
  }, 
  mounted() {
    // console.log('this is current player instance object', this.player)
    //http://9890.vod.myqcloud.com/9890_4e292f9a3dd011e6b4078980237cc3d3.f20.mp4
    // setTimeout(() => {
    //   console.log("dynamic change options", this.player);

    //   // change src
    //   // this.playerOptions.sources[0].src = 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm';

    //   // change item
    //   // this.$set(this.playerOptions.sources, 0, {
    //   //   type: "video/mp4",
    //   //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
    //   // })

    //   // change array
    //   // this.playerOptions.sources = [{
    //   //   type: "video/mp4",
    //   //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
    //   //  }]
    //   this.player.muted(false);
    // }, 5000);
  },
  created() {
    // setStore("show-admin-hader","false");
    //this.$emit("page-changed-event",true);
    //let id=this.$route.params.id;
    //this.getVideo(-1);
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      // console.log('player ended!', player)
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      // console.log('player Waiting!', player)
    },
    onPlayerPlaying(player) {
      // console.log('player Playing!', player)
    },
    onPlayerTimeupdate(player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    // player is ready
    playerReadied(player) {
      // seek to 10s
      console.log("example player 1 readied", player);
      //player.currentTime(10)
      // console.log('example 01: the player is readied', player)
    },
    getVideo(id) {
      getVideo(id).then(result => {
        
        if (result.success) {
          this.playerOptions.sources[0].src = result.data;          
        } else {
          this.$message.error(result.message);
        }
        
      });
    },
    onClose() {      
      this.$emit("onCloseDialog", false);
      this.$refs.videoPlayer.player.pause();
    },
    onOpen() {
      this.playerOptions.sources[0].src = this.url;  
        //this.getVideo(this.pid);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/videoPlayer.vue